'use strict';
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver from "./com.raquo.airstream.common.-Internal-Try-Observer.js";
import * as $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal from "./com.raquo.airstream.common.-Single-Parent-Signal.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable from "./com.raquo.airstream.core.-Base-Observable.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed from "./com.raquo.airstream.core.-Named.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction from "./com.raquo.airstream.core.-Transaction.js";
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal from "./com.raquo.airstream.core.-Writable-Signal.js";
import * as $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal from "./com.raquo.airstream.distinct.-Distinct-Signal.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dSuccess from "./scala.util.-Success.js";
var $p;
function $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option($thiz) {
  var this$1 = $thiz.yD.h();
  return (this$1.k() ? $thiz.yE : this$1);
}
export { $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option as $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option };
/** @constructor */
function $c_Lcom_raquo_airstream_split_SplitChildSignal(parent, initialValue, getMemoizedValue) {
  this.EG = null;
  this.EF = false;
  this.EH = null;
  this.yB = 0;
  this.ED = null;
  this.EE = null;
  this.EK = false;
  this.yG = null;
  this.EI = false;
  this.v0 = 0;
  this.yH = null;
  this.yE = null;
  this.yD = null;
  this.yF = null;
  this.yC = false;
  this.EJ = 0;
  this.yH = parent;
  this.yE = initialValue;
  this.yD = getMemoizedValue;
  this.EG = (void 0);
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_BaseObservable__$init$__V(this);
  this.yB = 0;
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__$init$__V(this);
  this.yG = (void 0);
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__$init$__V(this);
  this.yF = $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().l7();
  this.yC = false;
  this.EJ = ((1 + parent.v6) | 0);
}
export { $c_Lcom_raquo_airstream_split_SplitChildSignal as $c_Lcom_raquo_airstream_split_SplitChildSignal };
$p = $c_Lcom_raquo_airstream_split_SplitChildSignal.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_split_SplitChildSignal;
/** @constructor */
function $h_Lcom_raquo_airstream_split_SplitChildSignal() {
}
export { $h_Lcom_raquo_airstream_split_SplitChildSignal as $h_Lcom_raquo_airstream_split_SplitChildSignal };
$h_Lcom_raquo_airstream_split_SplitChildSignal.prototype = $p;
$p.dP = (function() {
  return this.EG;
});
$p.dd = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__defaultDisplayName__T(this);
});
$p.b = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dNamed.$f_Lcom_raquo_airstream_core_Named__displayName__T(this);
});
$p.gA = (function() {
  return this.EF;
});
$p.fm = (function() {
  return this.EH;
});
$p.ea = (function(x$1) {
  this.EF = x$1;
});
$p.gD = (function(x$1) {
  this.EH = x$1;
});
$p.f = (function(obj) {
  return (this === obj);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$systemIdentityHashCode(this);
});
$p.gs = (function() {
  return this.yB;
});
$p.kI = (function(x$1) {
  this.yB = x$1;
});
$p.hm = (function(observer) {
  observer.fY($j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this));
});
$p.ew = (function() {
  return this.ED;
});
$p.ey = (function() {
  return this.EE;
});
$p.hw = (function() {
  return this.EK;
});
$p.g1 = (function(x$1) {
  this.EK = x$1;
});
$p.hf = (function(x$0) {
  this.ED = x$0;
});
$p.hg = (function(x$0) {
  this.EE = x$0;
});
$p.l3 = (function() {
  return this.yG;
});
$p.rb = (function(x$1) {
  this.yG = x$1;
});
$p.b3 = (function() {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this);
});
$p.fW = (function(nextValue, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onNext__O__Lcom_raquo_airstream_core_Transaction__V(this, nextValue, transaction);
});
$p.fV = (function(nextError, transaction) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dInternal$002dTry$002dObserver.$f_Lcom_raquo_airstream_common_InternalTryObserver__onError__jl_Throwable__Lcom_raquo_airstream_core_Transaction__V(this, nextError, transaction);
});
$p.rc = (function() {
  return this.EI;
});
$p.tQ = (function() {
  return this.v0;
});
$p.kJ = (function(x$1) {
  this.v0 = x$1;
});
$p.u2 = (function(x$0) {
  this.EI = x$0;
});
$p.hn = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStart__V(this);
});
$p.ho = (function() {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__onStop__V(this);
});
$p.dT = (function() {
  return this.EJ;
});
$p.hp = (function() {
  $j_com$002eraquo$002eairstream$002ecore$002e$002dBase$002dObservable.$f_Lcom_raquo_airstream_core_WritableObservable__maybeWillStart__V(this.yH);
  var maybeInitialValue = $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option(this);
  if ((!maybeInitialValue.k())) {
    var x0 = maybeInitialValue.C();
    matchResult1: {
      if ((x0 !== null)) {
        var nextValue = x0.ac;
        var nextParentLastUpdateId = (x0.ad | 0);
        if ((nextParentLastUpdateId !== this.v0)) {
          this.ll(new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(nextValue), nextParentLastUpdateId);
          break matchResult1;
        } else {
          break matchResult1;
        }
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x0);
    }
  }
});
$p.ll = (function(nextValue, nextParentLastUpdateId) {
  $j_com$002eraquo$002eairstream$002ecommon$002e$002dSingle$002dParent$002dSignal.$f_Lcom_raquo_airstream_common_SingleParentSignal__updateCurrentValueFromParent__s_util_Try__I__V(this, nextValue, nextParentLastUpdateId);
  this.yE = $j_java$002elang$002e$002dObject.$m_s_None$();
});
$p.id = (function() {
  var this$1 = $p_Lcom_raquo_airstream_split_SplitChildSignal__pullValueFromParent__s_Option(this);
  var this$4 = (this$1.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(this$1.C().ac)));
  return (this$4.k() ? $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__tryNow__s_util_Try(this) : this$4.C());
});
$p.fX = (function(nextParentValue, transaction) {
  var this$1 = this.yD.h();
  if ((!this$1.k())) {
    var x0 = this$1.C();
    matchResult2: {
      if ((x0 !== null)) {
        var freshMemoizedInput = x0.ac;
        var lastParentUpdateId = (x0.ad | 0);
        this.v0 = lastParentUpdateId;
        if (((!this.yC) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.yF, $j_com$002eraquo$002eairstream$002ecore$002e$002dTransaction.$m_Lcom_raquo_airstream_core_Transaction$pendingTransactions$().l7()))) {
          this.yF = (void 0);
          this.yC = true;
          break matchResult2;
        } else {
          $j_com$002eraquo$002eairstream$002ecore$002e$002dWritable$002dSignal.$f_Lcom_raquo_airstream_core_WritableSignal__fireTry__s_util_Try__Lcom_raquo_airstream_core_Transaction__V(this, new $j_scala$002eutil$002e$002dSuccess.$c_s_util_Success(freshMemoizedInput), transaction);
          break matchResult2;
        }
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x0);
    }
  }
});
$p.eB = (function() {
  return this.yH;
});
$p.hi = (function(isSame) {
  return new $j_com$002eraquo$002eairstream$002edistinct$002e$002dDistinct$002dSignal.$c_Lcom_raquo_airstream_distinct_DistinctSignal(this, isSame, false);
});
$p.dS = (function() {
  return this;
});
var $d_Lcom_raquo_airstream_split_SplitChildSignal = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_split_SplitChildSignal, "com.raquo.airstream.split.SplitChildSignal", ({
  h9: 1,
  a1: 1,
  M: 1,
  ai: 1,
  ak: 1,
  au: 1,
  az: 1,
  as: 1,
  aQ: 1,
  aj: 1,
  ay: 1,
  b1: 1
}));
export { $d_Lcom_raquo_airstream_split_SplitChildSignal as $d_Lcom_raquo_airstream_split_SplitChildSignal };
